module.exports = __webpack_public_path__ + "img/elementwidths_jasa.e3e79f91.png";